import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from '../ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ChangeBillingStatusService extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  changeBillingStatusTrip(bodyRq: { note: string; tripstochange: any; billingstatusid: number }) {
    return this._http
      .put(constant.URL_CHANGE_BILLING_STATUS_TRIP, bodyRq, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-billing-status-trip/change-billing-status.service.ts